"use strict";

class StationSettingsGeneralCtrl {

    constructor($rootScope, $http, $mdToast, $scope, $cacheFactory)
    {
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$rootScope = $rootScope;

        this.$httpCache = $cacheFactory.get('$http');

        this.settings = {
            broadcast_default_published: "yes"
        };

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.timesettings.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

    }

    save() {
        this.$rootScope.saveDisabled = true;
        let data = this.settings;

        this.$http.put('/stationsettings/settings', data)
            .then(() => {

                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object=General',
                    hideDelay: 6000,
                    position: ('top right')
                });
                this.$rootScope.saveDisabled = false;

                this.$httpCache.removeAll();
            });
    }

    fetch() {
        this.$http.get('/stationsettings/settings').then(response => {
            // this.settings = response.data;
            angular.merge(this.settings, response.data);
        });
    }
}

StationSettingsGeneralCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$scope',
    '$cacheFactory'
];

module.exports = StationSettingsGeneralCtrl;